module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transaction-blank-form', {
    attrs: {
      "submit-label": "Добавить транзакцию",
      "transaction": _vm.transaction,
      "errors": _vm.errors,
      "form-type": "add"
    },
    on: {
      "submit": _vm.processTransactionForm
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a77338c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/forms/transaction/TransactionAddForm.vue
// module id = 674
// module chunks = 0